import { Injectable } from "@angular/core";
import { Message, MessageService as PrimeNGMessageService } from "primeng/api";

@Injectable({
  providedIn: "root",
})
export class MessageService {

  constructor(
    private messageService: PrimeNGMessageService,
  ) {}

  add(message: Message): void {
    this.messageService.add(message);
  }

  addAll(messages: Message[]): void {
    this.messageService.addAll(messages);
  }

  clear(key?: string): void {
    this.messageService.clear(key);
  }

  success(text: string): void {
    this.clear();
    return this.add({
      severity: "success",
      life: 30000,
      summary: text
    });
  }

  error(text: string): void {
    this.clear();
    return this.add({
      severity: "error",
      life: 30000,
      summary: text
    });
  }

  throwErrorResponse(response: any, defaultMessage?: string): boolean {
    if (!response || !response.success) {
      if (response.errors && Array.isArray(response.errors) && response.errors.length > 0) {
        response.errors.forEach((e: string) => {
          this.error(e);
        });
        return true;
      }

      this.error(defaultMessage || "Unable to process the request at this time. Please try again later.");
      return true;
    }
    return false;
  }

  throwEditPageErrorResponse(response: any, defaultMessage?: string): boolean {
    if (!response || !response.success) {
      if (response.errors && Array.isArray(response.errors) && response.errors.length > 0) {
        response.errors.forEach((e: string) => {
          this.error(e);
        });
        return true;
      }

      this.error(defaultMessage || "A Page with this title already exists. May need to permanently delete existing page.");
      return true;
    }
    return false;
  }

}
